import { render, staticRenderFns } from "./SettingSaleDiscountsPopup.vue?vue&type=template&id=555e51d0&scoped=true&"
import script from "./SettingSaleDiscountsPopup.vue?vue&type=script&lang=js&"
export * from "./SettingSaleDiscountsPopup.vue?vue&type=script&lang=js&"
import style0 from "./SettingSaleDiscountsPopup.vue?vue&type=style&index=0&id=555e51d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555e51d0",
  null
  
)

export default component.exports